<template>
    <div>
<!--        <strong>{{ $_.get(activity, "actorUser.name") }}</strong> created a new trigger.-->
        <span v-html="$t('notification.triggerAdded', {user:$_.get(activity, 'actorUser.name') })"></span>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "TriggerAdded",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>
